import { render, staticRenderFns } from "./CombinadosCon.vue?vue&type=template&id=2ce00ae2&scoped=true&"
import script from "./CombinadosCon.vue?vue&type=script&lang=js&"
export * from "./CombinadosCon.vue?vue&type=script&lang=js&"
import style0 from "./CombinadosCon.vue?vue&type=style&index=0&id=2ce00ae2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce00ae2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBtn,VIcon,VImg})
